import Model from '../Model'

export default class Group extends Model {
}
